export type GalleryCategory = 'exterior' | 'interior' | 'full'

export interface Transformation {
  id: string
  category: GalleryCategory
  before: string
  after: string
  title: { en: string; es: string }
  vehicle: string
  alt: { en: string; es: string }
}

export const transformations: Transformation[] = [
  {
    id: 'sedan-exterior',
    category: 'exterior',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/d14bf921-5162-4682-9143-49b680f8853b.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/e5e0d6e0-b82d-414d-9395-7339358f064c.jpg',
    title: { en: 'Deep exterior wash & polish', es: 'Lavado profundo y pulido exterior' },
    vehicle: 'Sedan · Basic package',
    alt: {
      en: 'Grey sedan before and after a deep exterior wash and polish',
      es: 'Sedán gris antes y después de un lavado exterior profundo y pulido',
    },
  },
  {
    id: 'truck-exterior',
    category: 'exterior',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/14c25b54-719e-4f19-bafc-8aacfe70cab7.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/abe0ceaf-35f1-4ce5-bca4-c7da3380c710.jpg',
    title: { en: 'Mud removal & paint restore', es: 'Remoción de lodo y restauración de pintura' },
    vehicle: 'Pickup truck · Basic package',
    alt: {
      en: 'White pickup truck before and after mud removal and paint restoration',
      es: 'Camioneta blanca antes y después de la remoción de lodo y restauración de pintura',
    },
  },
  {
    id: 'cabin-interior',
    category: 'interior',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/9a62058a-97f5-485d-a63c-9bf34f8727fa.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/ff5099cc-47b3-4711-a6e5-d9e7be3b0b37.jpg',
    title: { en: 'Front cabin deep detail', es: 'Detallado profundo de cabina delantera' },
    vehicle: 'Sedan · Complete detail',
    alt: {
      en: 'Car front cabin before and after a deep interior detail',
      es: 'Cabina delantera del auto antes y después de un detallado interior profundo',
    },
  },
  {
    id: 'suv-interior',
    category: 'full',
    before:
      'https://cdn.magicpatterns.com/patterns/generated-images/cb029b23-b3e6-4e54-944e-a15fce2a00dd.jpg',
    after:
      'https://cdn.magicpatterns.com/patterns/generated-images/c806781f-8ed3-46c5-baec-9ff6fa86bf00.jpg',
    title: { en: 'Full SUV reset, seats to cargo', es: 'SUV completa, asientos y cajuela' },
    vehicle: 'SUV · Complete detail',
    alt: {
      en: 'SUV rear seats and cargo area before and after a complete deep clean',
      es: 'Asientos traseros y cajuela de SUV antes y después de una limpieza profunda completa',
    },
  },
]

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/u6GqTPGtt1WoFH8D2MW8Xo/Banner_Los_brothers.png'

export const teamImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/c80f8d8f-6dfa-425f-9041-d7979df1fae4.jpg'

export const instagramTiles = [
  transformations[1].after,
  transformations[3].after,
  teamImage,
  transformations[0].after,
  transformations[2].after,
  transformations[1].before,
  transformations[3].before,
  transformations[0].before,
  transformations[2].before,
]
